export enum YospaceVastProperties {
  /**
   * Defines the source ad server of the advert.
   */
  ADSYSTEM = 'AdSystem',
  /**
   * Defines the common name of the advert.
   */
  ADTITLE = 'AdTitle',
  /**
   * Defines an identifier used to compare impression-level data across systems.
   */
  ADSERVINGID = 'AdServingId',
  /**
   * Defines the category of the advert content.
   */
  CATEGORY = 'Category',
  /**
   * Defines a longer description of the advert.
   */
  DESCRIPTION = 'Description',
  /**
   * Defines the advertiser name.
   */
  ADVERTISER = 'Advertiser',
  /**
   * Defines the pricing element of the advert.
   */
  PRICING = 'Pricing',
  /**
   * Defines a URI to any resource file having to do with collecting survey data.
   */
  SURVEY = 'Survey',
  /**
   * Defines the number of seconds in which the ad is valid for execution.
   */
  EXPIRES = 'Expires',
}
